import moment from 'moment';
import { groups } from './devdata';
import AppUsersClient from "../clients/AppUsersClient";

const resource = '/salaryrate';

export default {
  getAllSalaryRatesForYear: (year) => AppUsersClient.get(`${resource}/getAllSalaryRatesForYear/${year}`),
  updateSalaryRate(dto) {
    return new Promise(function(resolve, reject) {        
      AppUsersClient
      .put(`${resource}/updateSalaryRate`, dto)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  createSalaryRate(dto) {
    return new Promise(function(resolve, reject) {        
      AppUsersClient
      .post(`${resource}/createSalaryRate`, dto)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  }
};
